export default __webpack_public_path__ + "static/media/best_wallet_bot.9414575d.svg";